import api from './api';

export function getDocumentTypes(type) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/documents?process=${type}`);
}

export function downloadDigitalDocuments(idCredito) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredito}/payers/documents-templates`);
}

export function sendUploadedDocuments(data) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/payers/documents`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function getDigitalDocuments() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}msdocumentviewer/controller/obtener/tipos/documental/digicredito`);
}
